import { api } from '@/core/api/';

const baseUrl = '/api/interfaces';

const getApplications = async () => await api.get(`${baseUrl}/applications`);

const getModules = async (applicationId) =>
  await api.get(`${baseUrl}/${applicationId}/modules`);

const getByFilters = async (filters) =>
  await api.get(baseUrl, { params: filters });

const getById = async (interfaceId) =>
  await api.get(`${baseUrl}/${interfaceId}`);

const save = async (model) => await api.put(baseUrl, model);

const getLevels = async () => await api.get(`${baseUrl}/levels`);

const getLevelCenters = async (levelName) =>
  await api.get(`${baseUrl}/centers`, { params: { levelName } });

const getProposalAreas = async () => await api.get(`${baseUrl}/proposalareas`);

const getServiceOfficeTypesByArea = async (id) =>
  await api.get(`${baseUrl}/officetypesby/${id}`);

export default {
  getApplications,
  getModules,
  getByFilters,
  getById,
  save,
  getLevels,
  getLevelCenters,
  getProposalAreas,
  getServiceOfficeTypesByArea,
};
